import React, { createContext, useState } from "react";

export const navbarToggleContext = createContext();

export const NavbarToggleContextProvider = (props) => {
    const [navbarToggle, setNavbarToggle] = useState(false);

    const handleNavbarToggle = () => {
        setNavbarToggle(!navbarToggle);
    };

    const handleNavbarDeactive = () => {
        setNavbarToggle(false);
    };

    const contextValue = {
        navbarToggle,
        handleNavbarToggle,
        handleNavbarDeactive,
    };

    return (
        <navbarToggleContext.Provider value={contextValue}>
            {props.children}
        </navbarToggleContext.Provider>
    );
};
